import { getRequest, postRequest, patchRequest, deleteRequest } from './seviceHelpers';

export default {
    inviteMember: async (teamId, invitation) => postRequest(`/teams/${teamId}/users`, invitation),
    removeMember: async (teamId, userId) => deleteRequest(`/teams/${teamId}/users/${userId}`),
    getUsers: async teamId => getRequest(`/teams/${teamId}/users`),
    getInvitations: async teamId => getRequest(`/teams/${teamId}/invitations`),
    revokeInvitation: async invitationId => deleteRequest(`/invitations/${invitationId}`),
    changeAccess: async (teamId, userId, role) => patchRequest(`/teams/${teamId}/users/${userId}`, {
        data: { type: 'teamuser', attributes: { role } },
    }),
};
